import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.board_id',
  })

  return useMemo(() => {
    if (id === 'new') {
      return [{ id: null }]
    }

    if (!rdata) return rdata

    let { stages, ...data } = rdata

    return {
      stages: [...stages].sort((a, b) => {
        if (a.done && !b.done) return 1 // a after b
        if (!a.done && b.done) return -1 // a before b
        return a.order - b.order // otherwise sort by order
      }),
      ...data,
      ...data?.metadata,
    }
  }, [rdata, id])
}
